export default {"src":"/assets/turbo/f322db0c/ackermannch/_next/static/media/favicon.c39a2a5c.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};